import { jsxs, jsx } from 'react/jsx-runtime';
import './PaymentTab.module.scss.js';
import classNames from 'classnames';
import { P2, P1 } from '@zooplus/ui-components';
import StateBox from '../../../components/StateBox/StateBox.js';
import PaymentLogo from '../PaymentLogo/PaymentLogo.js';
import { useTranslation } from '../../../hooks/useTranslations.js';

const pm_text = {
    K: 'general.payment.credit_card',
    CD: 'general.payment.cashondelivery',
    KL: 'general.payment.KL.name',
    KO: 'general.payment.KO.name',
    R: 'general.payment.invoice',
    VK: 'payment.prepaired.description',
    TY: 'Instant bank payment',
};
const pm_data_zta = {
    R: 'inputLabelR',
    BS: 'inputLabelBS',
    ID: 'inputLabelID',
    AP: 'inputLabelAp',
    BC: 'bancontactLabel bancontactCardLabel',
    BM: 'bancontactLabel bancontactMobileLabel',
    CD: 'CDWrapper',
    K: '',
    DP: 'DOTPAY',
    OP: 'inputLabelOP',
    MB: 'inputLabelMultibanco',
    PP: 'inputLabelPP',
    PT: 'inputLabelPT',
    VK: 'inputLabelVK',
    TY: 'inputLabelTY',
    TW: 'inputLabelTW',
    KL: 'inputLabelKL',
    KO: 'inputLabelKO',
};
const PaymentTab = ({ paymentMethod, className, url, variant = 'default', title, onClick, ...rest }) => {
    const { t } = useTranslation();
    return (jsxs(StateBox, { variant: variant, className: classNames({ paymentTabTitle: title }, className, 'paymentTab'), "data-zta": "paymentTab", "data-testid": pm_data_zta[paymentMethod], onClick: onClick, ...rest, children: [jsx(PaymentLogo, { className: 'tabLogo', method: paymentMethod, url: url }), !url && paymentMethod && pm_text[paymentMethod] && (jsx(P2, { className: "paymentTabTitle", children: t(pm_text[paymentMethod]) })), title && jsx(P1, { className: "paymentTabSecondTitle", children: title })] }));
};

export { PaymentTab as default, pm_text };
//# sourceMappingURL=PaymentTab.js.map
